import { ChipItem, ParamBetTXCB, PayloadBodyTopicTXCB, PayloadBodyUserQueueTXCB, StoreBetTXCB } from 'models/txcb-model';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import txcbFunction from '../txcb-function';
import PlateBowlTXCB from '../plate-bowl-txcb';
import './board-txcb.scss';
import ReactDOMServer from 'react-dom/server';
import ChipsTxcb from '../chips-txcb';
import { reloadBalance } from 'utils/function';
import { numberWithCommas } from 'utils/time-utils';
interface Props {
    balance: string;
    bodyTopic: PayloadBodyTopicTXCB;
    userQueue: PayloadBodyUserQueueTXCB;
    onBet: (action: string, payload: ParamBetTXCB) => void;
    onUpdatePhien: (value: { id: string; result: number[] }[]) => void;
    lspData: { id: string; result: number[] }[];
    onChangeMsg: (inputData: string) => void;
}
const defaultParams: ParamBetTXCB = {
    taixiuId: '',
    userId: 0,
    loginname: '',
    betamount: 0,
    typed: 0,
    userType: 0,
    betfrom: 0,
};

export default function BoardTXCB(props: Props) {
    const { balance, bodyTopic, userQueue, onBet, onUpdatePhien, lspData, onChangeMsg } = props;

    const [paramsBet, setParamsBet] = useState<ParamBetTXCB>(defaultParams);
    let objAudio = useMemo(() => new Audio(), []);

    const timerFinishRef = useRef<HTMLDivElement>(null);
    const moneyTaiRef = useRef<HTMLDivElement>(null);
    const moneyXiuRef = useRef<HTMLDivElement>(null);
    const chipsListRef = useRef<any[]>([]);
    const placeBetTaiRef = useRef<HTMLDivElement>(null);
    const placeBetXiuRef = useRef<HTMLDivElement>(null);

    const isNextPhien = useRef(false);

    const [timerCount, setTimerCount] = useState('');
    const [issue, setIssue] = useState('');

    const [moneyCountTai, setMoneyCountTai] = useState(0);
    const [moneyCountXiu, setMoneyCountXiu] = useState(0);
    const [countUser, setCountUser] = useState<StoreBetTXCB>({ tai: 0, xiu: 0 });
    const [result, setResult] = useState<number[] | null>(null); // phiên cược
    const [timerFinish, setTimerFinish] = useState('');
    const [chipValue, setChipValue] = useState(1000);

    const [stateBtnBet, setStateBtnBet] = useState<'TAI' | 'XIU' | ''>('');
    const [storeMyBet, setStoreMyBet] = useState<StoreBetTXCB>({ tai: 0, xiu: 0 }); // tiền cược đã confirm

    const [currentMyBet, setcurrentMyBet] = useState<StoreBetTXCB>({ tai: 0, xiu: 0 }); //tiền cược chưa confirm
    const [activePlaceWin, setActivePlaceWin] = useState<'TAI' | 'XIU' | ''>('');

    const [tkBoardList, setTkBoardList] = useState<{ id: string; result: number[] }[]>([]);
    const [isPlateClose, setIsPlateClose] = useState(false); // toggle nặn kết quả

    const moneyWin = useRef<number>(0);

    const updateMoneyWin = (value: number) => {
        moneyWin.current = value;
    };

    const handleGetMsg = (msg: any) => {
        onChangeMsg(msg);
    };

    const isShowingWin = useRef(false);

    useEffect(() => {
        //bắt đầu phiên mới
        if (bodyTopic.cmd === 1) {
            paramsBet.taixiuId = bodyTopic.id;

            setResult(null);
            setIssue(bodyTopic.id);
            setTimerFinish('');
            //đếm tổng cược tài
            if (bodyTopic.at !== 0 && bodyTopic.cd !== 0) {
                if (moneyTaiRef.current) {
                    txcbFunction.animateValue(moneyTaiRef.current, moneyCountTai, bodyTopic.at, 200, () => {
                        setMoneyCountTai(bodyTopic.at);
                    });
                }
            }

            // đếm tổng cược xỉu
            if (bodyTopic.ax !== 0 && bodyTopic.cd !== 0) {
                if (moneyXiuRef.current) {
                    txcbFunction.animateValue(moneyXiuRef.current, moneyCountXiu, bodyTopic.ax, 200, () => {
                        setMoneyCountXiu(bodyTopic.ax);
                    });
                }
            }

            //thời gian cược
            setTimerCount(`0${bodyTopic.cd}`.slice(-2));

            //count user cược
            setCountUser({ tai: bodyTopic.ut, xiu: bodyTopic.ux });

            //trả tiền cân cửa
            if (bodyTopic.cd === 0) {
                handleGetMsg('Trả tiền cân cửa!');
                const minBet = Math.min(bodyTopic.at, bodyTopic.ax);
                setMoneyCountTai(minBet);
                setMoneyCountXiu(minBet);
            }
        }

        //kết quả phiên và hiệu ứng mở thưởng
        if (bodyTopic.cmd === 5 && bodyTopic.cd === -1) {
            let hisPhien = lspData;
            const lspLast = { id: bodyTopic['id'], result: bodyTopic['rs'] || [] };
            hisPhien = [lspLast, ...hisPhien];
            hisPhien.pop();
            onUpdatePhien(hisPhien);
            setResult(bodyTopic.rs);
        }

        //count finish phiên
        if (bodyTopic.cmd === 2 && bodyTopic.cd <= 14) {
            setTimerFinish(`0${bodyTopic.cd}`.slice(-2));
            if (timerFinishRef.current) {
                timerFinishRef.current.style.transform = 'scale(1.25)';
                setTimeout(() => {
                    if (timerFinishRef.current) {
                        timerFinishRef.current.style.transform = 'scale(1)';
                    }
                }, 160);
            }
            if (bodyTopic.cd === 0) {
                handleGetMsg('Bắt đầu phiên mới');
                setStoreMyBet({ tai: 0, xiu: 0 });
                setMoneyCountTai(0);
                setMoneyCountXiu(0);
                setParamsBet(defaultParams);
                updateMoneyWin(0);
                isShowingWin.current = false;
            }
        }
        isNextPhien.current = false;
        if (bodyTopic.cmd === 2 && bodyTopic.cd <= 17) {
            isNextPhien.current = true;
        }
    }, [bodyTopic]);

    useEffect(() => {
        if (userQueue.cmd === 3) {
            //bắt đầu cược
            if (userQueue.status === 0) {
                setcurrentMyBet({ xiu: 0, tai: 0 });
                paramsBet.betamount = 0;
                handleGetMsg('Đặt cược thành công');
                reloadBalance();
            }
        }

        //bắt đầu lịch sử phiên
        if (userQueue.cmd === 6) {
            const listHisPhien = userQueue.data
                .filter((item) => item.result !== null)
                .map((item) => {
                    return {
                        id: item['id'],
                        result: item['result'].split('').map(Number),
                    };
                })
                .slice(0, 75);
            onUpdatePhien(listHisPhien);

            const listDotHisPhien: { id: string; result: number[] }[] = JSON.parse(JSON.stringify(listHisPhien))
                .filter((_: any, idx: number) => idx < 10)
                .reverse();
            setTkBoardList(listDotHisPhien);
        }

         // chỉ chạy khi có kết quả phiên, dĩa đã mở, và chưa show win
        if (
            userQueue.cmd === 4 &&
            userQueue.amount > 0 &&
            !isShowingWin.current &&
            result &&            // đảm bảo đã có kết quả
            !isPlateClose         // dĩa đã mở (isPlateClose = false)
        ) {
            isShowingWin.current = true;

            setTimeout(() => {
                updateMoneyWin(userQueue.amount);
                setTimeout(() => {
                    updateMoneyWin(0);
                }, 3000);
            }, 1000);
        }

        // lấy tổng cược hiện tại
        if (userQueue.cmd === 13) {
            const moneyBet = Number(userQueue.rs.split(':')[0]);
            const getTyped = userQueue.rs.split(':')[1];
            setStoreMyBet({
                tai: getTyped === '1' ? moneyBet : 0,
                xiu: getTyped === '2' ? moneyBet : 0,
            });
        }
    }, [userQueue, result, isPlateClose]);

    useEffect(() => {
        if (result && !isPlateClose) {
            setTimeout(() => {
                handleOpenWin(result);
            }, 3200);
        } else {
            setActivePlaceWin('');
        }
    }, [result]);

    const handleOpenWin = (result: number[]) => {
        const total = result.reduce((a, b) => a + b, 0);
        setActivePlaceWin(total > 10 ? 'TAI' : 'XIU');
        setTkBoardList((list) => {
            const newList = [...list, { id: issue, result }];
            return newList.slice(-10); // đảm bảo giới hạn 10 phần tử
        });
    };

    const selectBet = (place: 'TAI' | 'XIU') => {
        setStateBtnBet(place);
    };

    const renderHTMLChip = (item: ChipItem) => {
        return (
            <div style={{ cursor: 'unset' }} className="chip-item">
                <img src={require(`assets/images/chips/${item.icon}`)} alt="" />
                <p>{item.txt}</p>
            </div>
        );
    };

    const selectChip = (chipSelect: ChipItem) => {
        setChipValue(chipSelect.val);
        if ((storeMyBet.tai > 0 && stateBtnBet === 'XIU') || (storeMyBet.xiu > 0 && stateBtnBet === 'TAI')) {
            handleGetMsg('Không thể đặt đối nghịch');
            return;
        }

        if (stateBtnBet !== '') {
            let placeBetEl = placeBetTaiRef.current;

            setcurrentMyBet((obj) => {
                if (stateBtnBet === 'TAI') {
                    obj = { ...obj, tai: obj.tai + chipSelect.val };
                }
                if (stateBtnBet === 'XIU') {
                    placeBetEl = placeBetXiuRef.current;
                    obj = { ...obj, xiu: obj.xiu + chipSelect.val };
                }
                //chip effect bet
                const chipCloneJXS = renderHTMLChip(chipSelect);
                const htmlString = ReactDOMServer.renderToStaticMarkup(chipCloneJXS);
                if (placeBetEl) {
                    txcbFunction.effectChipBet(htmlString, chipsListRef.current, placeBetEl, chipSelect.val, 0.5);
                }

                return obj;
            });
        } else {
            handleGetMsg('Vui lòng chọn cửa cược');
        }
    };

    const confirmBet = () => {
        if (isNextPhien.current) {
            handleGetMsg('Phiên mới chưa bắt đầu');
            return;
        }
        if (stateBtnBet === '') {
            handleGetMsg('Vui lòng chọn cửa cược');
            return;
        }
        if (currentMyBet.tai === 0 && currentMyBet.xiu === 0) {
            handleGetMsg('Vui lòng đặt tiền cược');
            return;
        }

        if (currentMyBet.tai > 0) {
            paramsBet.typed = 1;
            paramsBet.betamount = currentMyBet.tai;
          } else if (currentMyBet.xiu > 0) {
            paramsBet.typed = 2;
            paramsBet.betamount = currentMyBet.xiu;
          }

        if (paramsBet.betamount > Number(balance)) {
            handleGetMsg('Số dư không đủ!');
            return;
        }
        
        if (paramsBet.betamount < 1000 || paramsBet.betamount > 100000000) {
            handleGetMsg('Cược ít nhất 1K, nhiều nhất 100tr!');
            return;
          }

        if (currentMyBet.tai > 0) {
            paramsBet.typed = 1;
            paramsBet.betamount = currentMyBet.tai;
        } else if (currentMyBet.xiu > 0) {
            paramsBet.typed = 2;
            paramsBet.betamount = currentMyBet.xiu;
        }

        //check platform
        paramsBet.betfrom = 3;

        onBet('/topic/bet', paramsBet);
    };

    const cancelBet = () => {
        setcurrentMyBet({ tai: 0, xiu: 0 });
    };

    const allBet = () => {
        if (stateBtnBet === '') {
            handleGetMsg('Vui lòng chọn cửa cược');
            return;
        } else {
            if (stateBtnBet === 'TAI') {
                setcurrentMyBet({ xiu: 0, tai: Number(balance) });
            }
            if (stateBtnBet === 'XIU') {
                setcurrentMyBet({ tai: 0, xiu: Number(balance) });
            }
        }
    };

    const generateDotTK = (result?: number[]) => {
        if (!result || result.length === 0) return <div className="tk-item">0</div>;
        const totalResult = result.reduce((a, b) => a + b, 0);
        return <div className={`tk-item ${totalResult > 10 ? 'tai' : ''}`}>{totalResult}</div>;
    };

    return (
        <div className="board-txcb-container">

            <div className={`moneyWin ${moneyWin.current !== 0 ? "showMoney" : ""}`} >
                <span>+{moneyWin.current.toLocaleString()}</span>
            </div>
            
            <div className="table-bet">
                <img className="table-img" src={require(`assets/images/txcanban/table.png`)} alt="" />
                <div className="board-inner">
                    <div className="board-txcb">
                        <div className="balance">
                            <p>{new Intl.NumberFormat().format(Number(balance || 0))}</p>
                        </div>
                        <div className="plate-count">
                            <PlateBowlTXCB
                                timerCount={timerCount}
                                result={result}
                                isPlateClose={isPlateClose}
                                onToggleHand={() => setIsPlateClose(!isPlateClose)}
                                onOpenWin={handleOpenWin}
                            />
                        </div>
                        <div className="place-group over-place">
                            <div className="group-user left">
                                <p>{countUser.tai}</p>
                                <img src={require(`assets/images/txcanban/icon-users.png`)} alt="" />
                            </div>
                            <div className={`text-place ${activePlaceWin === 'TAI' ? 'active' : ''}`}>
                                <img className="light-win" src={require(`assets/images/icons/light-effect.png`)} alt="" />
                                <img className="text-icon" src={require(`assets/images/txcanban/text-tai.png`)} alt="" />
                            </div>
                            <div className="total-bet">
                                <div className="total-bet-content">
                                    <p ref={moneyTaiRef}>{new Intl.NumberFormat().format(moneyCountTai | 0)}</p>
                                </div>
                            </div>
                            <div className="bet-action" ref={placeBetTaiRef}>
                                <button className="btn-reset btn-bet" onClick={() => selectBet('TAI')}>
                                    <img
                                        className={`icon-btn ${stateBtnBet === '' || stateBtnBet === 'XIU' ? 'show' : ''}`}
                                        src={require(`assets/images/txcanban/btn-tai.png`)}
                                    />

                                    <div className={`place-my-bet ${stateBtnBet === 'TAI' ? 'show' : ''}`}>
                                        <img className="icon-select" src={require(`assets/images/txcanban/btn-tai-active.png`)} alt="" />
                                        <p>{numberWithCommas(currentMyBet.tai)}</p>
                                    </div>
                                </button>
                            </div>
                            <div className="total-my-bet">
                                <p>{numberWithCommas(storeMyBet.tai)}</p>
                                <img className="icon-money" src={require(`assets/images/txcanban/icon-money.png`)} alt="" />
                            </div>
                        </div>
                        <div className="place-group under-place">
                            <div className="group-user right">
                                <img src={require(`assets/images/txcanban/icon-users.png`)} alt="" />
                                <p>{countUser.xiu}</p>
                            </div>
                            <div className={`text-place ${activePlaceWin === 'XIU' ? 'active' : ''}`}>
                                <img className="light-win" src={require(`assets/images/icons/light-effect.png`)} alt="" />
                                <img className="text-icon" src={require(`assets/images/txcanban/text-xiu.png`)} alt="" />
                            </div>
                            <div className="total-bet">
                                <div className="total-bet-content">
                                    <p ref={moneyXiuRef}>{new Intl.NumberFormat().format(moneyCountXiu | 0)}</p>
                                </div>
                            </div>
                            <div className="bet-action" ref={placeBetXiuRef}>
                                <button className="btn-reset btn-bet" onClick={() => selectBet('XIU')}>
                                    <img
                                        className={`icon-btn ${stateBtnBet === '' || stateBtnBet === 'TAI' ? 'show' : ''}`}
                                        src={require(`assets/images/txcanban/btn-xiu.png`)}
                                    />
                                    <div className={`place-my-bet ${stateBtnBet === 'XIU' ? 'show' : ''}`}>
                                        <img className="icon-select" src={require(`assets/images/txcanban/btn-xiu-active.png`)} alt="" />
                                        <p>{numberWithCommas(currentMyBet.xiu)}</p>
                                    </div>
                                </button>
                            </div>
                            <div className="total-my-bet">
                                <img className="icon-money" src={require(`assets/images/txcanban/icon-money.png`)} alt="" />
                                <p>{numberWithCommas(storeMyBet.xiu)}</p>
                            </div>
                        </div>
                        <div className="issue">#{((issue && issue.split('-')) || [])[1]}</div>
                        <div className={`timer-finish ${timerFinish === '' ? 'hide' : ''}`} ref={timerFinishRef}>
                            {timerFinish}
                        </div>
                    </div>
                </div>
                <img className="bg-chip" src={require(`assets/images/chips/bg-chip.png`)} alt="" />

                <div className="bar-tk">
                    <div className="bar-tk-inner">
                        <img className="bar-bg" src={require(`assets/images/txcanban/bar-tk.png`)} alt="" />
                        <div className="bar-tk-content">
                        {tkBoardList.map((item, index) => (
                            <React.Fragment key={`${item.id}-${index}`}>
                                {generateDotTK(item.result)}
                            </React.Fragment>
                        ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="chips-minigame">
                <ChipsTxcb ref={chipsListRef} valueActive={chipValue} onSelect={selectChip} />
            </div>
            <div className="txcb-action">
                <button className="btn-reset btn-action" onClick={cancelBet}>
                    <img className="action-icon" src={require(`assets/images/txcanban/btn-cancel.png`)} alt="" />
                </button>
                <button className="btn-reset btn-action" onClick={confirmBet}>
                    <img className="action-icon" src={require(`assets/images/txcanban/btn-bet.png`)} alt="" />
                </button>
                <button className="btn-reset btn-action" onClick={allBet}>
                    <img className="action-icon" src={require(`assets/images/txcanban/btn-allin.png`)} alt="" />
                </button>
            </div>
        </div>
    );
}
